module.exports = __webpack_public_path__ + "static/media/menu.ddc43ff4.png";